/* !
 * articles.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const brandDIR = location.pathname.split('/')[2];

	const selectTag = () => {
		const tagList = document.querySelector('.js-articles-tagList');
		// URL判定（/en/だったら英語版のタグ名を使用）
		const isEnglish = location.pathname.includes('/en/');
		const jsonURL = isEnglish ? `/ajax/en/news/${brandDIR}/tag_list.json` : `/ajax/news/${brandDIR}/tag_list.json`;

		fetch(jsonURL).then(response => response.json()).then(data => {
			if (data.rt_bn_tag_list.length) {
				data.rt_bn_tag_list.forEach(ele => {
					const option = document.createElement('option');
					option.textContent = isEnglish ? ele.cf_n_tags.cf_nt_name_en : ele.cf_n_tags.cf_nt_name_jp;
					let categoryCode = ele.cf_n_tags.cf_nt_url;
					option.value = categoryCode;
					if(categoryCode !== 'orientstar' && categoryCode !== 'orient') {
						tagList.appendChild(option);
					}
				});

				// カレントタグ反映
				if (location.search.match(/p_tag=[a-zA-Z]+/)) {
					let current = location.search.match(/p_tag=[a-zA-Z]+/)[0].replace(/p_tag=/, '');
					tagList.value = current;
				}

				tagList.addEventListener('change', () => {
					let href = location.pathname;
					if (tagList.value) {
						href += '?p_tag=' + tagList.value;
					}
					location.href = href;
				});
			}
		});
	};


	// 移行ページ(Load More)
	const loadMore = () => {
		const loadMoreButton = document.querySelector('.js-article-more');
		const items = document.querySelectorAll('.js-article-item');
		if (!loadMoreButton) return;
		
		const itemsPerPage = 3;
		let currentIndex = itemsPerPage;
		
		// 初期表示（最初の3件）
		items.forEach((item, index) => {
			if (index < itemsPerPage) {
				item.classList.add('is-visible');
			}
		});
		
		// 全件表示済みの場合はボタンを無効化
		if (items.length <= itemsPerPage) {
			loadMoreButton.classList.add('is-disable');
			loadMoreButton.textContent = 'No more post';
			
		}
		
		loadMoreButton.addEventListener('click', () => {
			// 次の3件を表示
			for (let i = currentIndex; i < currentIndex + itemsPerPage && i < items.length; i++) {
				items[i].classList.add('is-visible');
			}
			
			currentIndex += itemsPerPage;
			
			// 全件表示したらボタンを無効化
			if (currentIndex >= items.length) {
				loadMoreButton.classList.add('is-disable');
				loadMoreButton.textContent = 'No more post';
			}
		});
	};


	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const articlesFUNCTIONS = () => {
		selectTag();
		loadMore();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { articlesFUNCTIONS(); }) : articlesFUNCTIONS();

})(window.FUNCTIONS);
